import React, { useContext } from "react";
import { Route, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/auth/index";
import { PayLoadCtx, RoleCtx } from "../lib/context";
const DoctorRoute = ({ children }) => {
    const { payload } = useContext(PayLoadCtx);
    const { role } = useContext(RoleCtx);
    return payload && role === "D" ? <AuthLayout role="Doctor">{children}</AuthLayout> : <Navigate to="/" />;
};

export default DoctorRoute;
